import React from 'react'
import { Link } from 'react-router-dom'
import fun1 from '../assets/fun1.webp'
import fun2 from '../assets/fun2.webp'
import fun3 from '../assets/fun3.webp'
import about2 from '../assets/about2.webp'
import play1 from '../assets/play1.webp'
import f1 from '../assets/f1.webp'
import f2 from '../assets/f2.webp'
import f3 from '../assets/f3.webp'
import boy from '../assets/boy.webp'
import man from '../assets/man.webp'
import logo1 from '../assets/logo1.webp'
import logo2 from '../assets/logo2.webp'
import logo3 from '../assets/logo3.webp'
import logo4 from '../assets/logo4.webp'
import logo5 from '../assets/logo5.webp'
import BlogCard from './BlogCard'

export default function About() {


  return (<div>

    <div className=' bg-hero-pattern -z-10' >
      <div className=' flex justify-center items-center  flex-col bg-[rgb(59,68,152,0.9)] bg-cover bg-no-repeat  h-[60vh]   text-white xl:px-[9vw]  text-center   ' >
        <p
          className='text-xl tracking-wide  p-2'>ABOUT US</p>
        <h1 h1 className='text-4xl lg:text-7xl p-2 tracking-wide font-semibold'>About Predent</h1>
        <span className='mt-2 p-3 text-xl font-sans '>
          <Link to='/home' className='hover:text-gray-400'>Home</Link> / About
        </span>
      </div>
    </div>


    <div className=" sm:grid py-5 grid-cols-2 justify-between gap-10 xl:px-[9vw] ">

      <div className='mt-5 ml-3'>
        <p className='text-[#009640] text-xl tracking-wide' >SCIENCE 2005</p>
        <h1 className=' text-4xl sm:text-6xl sm:mt-5 text-blue-900 tracking-wider py-5 ' >Keep Your <span className='text-[#009640]'>Teeth <br /> Clean</span> & Shine</h1>
        <span className='font-sans text-justify' >Dental care is the maintenance of healthy teeth  and the practice of keeping the mouth and teeth clean pur sue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone</span>
        <p className=' text-blue-900 py-3 text-xl font-semibold font-sans'>You need to brush your teeth everyday for healty teeth and simle.</p>
        <div className='flex gap-10 items-center mt-5 text-xl' >
          <Link to='/contact' className='underline text-[#009640]' >Book Now</Link>
          <img src={play1} alt="play1" className='hover:rotate-[360deg] duration-1000  transition cursor-pointer ' />
          <p className='text-blue-900 hover:text-green-900 cursor-pointer' >Video Tour</p>
        </div>

      </div>
      <div className='sm:block hidden' >
        <img src={about2} alt="about1" />
      </div>
    </div>
    <div className="flex justify-around items-center gap-10 my-20 flex-col sm:flex-row xl:px-[9vw] ">
      <div className='flex gap-5 items-center ' >
        <img src={fun1} alt="fun1" />
        <div>
          <p className='text-2xl text-blue-900' >$65</p>
          <span className='font-sans' >Dental Implant</span>
        </div>
      </div>
      <div className='flex gap-5 items-center' >
        <img src={fun2} alt="fun2" />
        <div>
          <p className='text-2xl text-blue-900' >$135</p>
          <span className='font-sans' >Teeth Whitening</span>
        </div>
      </div>
      <div className='flex gap-5 items-center' >
        <img src={fun3} alt="fun3" />
        <div>
          <p className='text-2xl text-blue-900' >$230</p>
          <span className='font-sans' >Dental Crown</span>
        </div>
      </div>
    </div>


    <div className="flex gap-10 flex-col lg:flex-row justify-center mx-4 my-20">
      <img src={boy} alt="boy" className='shadow-2xl ' />
      <div>
        <p className='text-[#009640] text-2xl tracking-wide'>WHY WE BEST</p>
        <h1 className=' text-4xl lg:text-6xl font-semibold  sm:mt-5 text-blue-900 tracking-wider py-3 ' >People <span className='text-[#009640]'>Choose Us</span> because ...</h1>
        <p className='  py-3 text-lg font-sans'>Dental care is the maintenance of healthy teeth and the practice of keeping the teeth clean.</p>
        <div>
          <div className='flex gap-4 mt-4 ' >
            <img src={f1} alt="img" className='h-16 m-2' />
            <div>
              <h1 className='text-blue-900 text-2xl font-semibold ' >Expert Dentist</h1>
              <p className='font-sans my-1' >Dental care is the maintenance teeth the practice of keeping mouth clean sue pleasure rationally encounter</p>
            </div>
          </div>
          <div className='flex gap-4 mt-4 ' >
            <img src={f2} alt="img" className='h-16 m-2' />
            <div>
              <h1 className='text-blue-900 text-2xl font-semibold ' >24/7 Advance Care</h1>
              <p className='font-sans my-1' >Dental care is the maintenance teeth the practice of keeping mouth clean sue pleasure rationally encounter</p>
            </div>
          </div>
          <div className='flex gap-4 mt-4 ' >
            <img src={f3} alt="img" className='h-16 m-2' />
            <div>
              <h1 className='text-blue-900 text-2xl font-semibold ' >Available Products</h1>
              <p className='font-sans my-1' >Dental care is the maintenance teeth the practice of keeping mouth clean sue pleasure rationally encounter</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="flex flex-col justify-center gap-10 sm:flex-row m-4 my-10">

      <div>
        <p className='text-[#009640] text-2xl tracking-wide'>TESTIMONIALS</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-5 text-blue-900 tracking-wider py-3 ' >Happy  <span className='text-[#009640]'>Patients </span>with <br /> <span className='text-[#009640]'>Satisfaction </span>words</h1>
        <p className='font-sans my-1' >Dental care is the maintenance teeth the practice of keeping mouth clean sue pleasure rationally encounter</p>
        <p>Albert Rusho (Root Canals)</p>
      </div>
      <div className='bg-circle bg-contain  bg-no-repeat ' >
        <img src={man} alt="man" className='m-4 ' />
      </div>

    </div>

    <div className='flex flex-wrap justify-center  items-center m-4 ' >
      <div> <p className='text-[#009640] text-2xl text-center tracking-wide'>OUR BLOG</p>
        <h1 className=' text-4xl lg:text-6xl font-semibold  sm:mt-3 text-blue-900 tracking-wider py-3 ' > Latest     <span className='text-[#009640]'>Post </span>from our   <span className='text-[#009640]'>Blogs </span>Happy</h1></div>
    </div>
    <BlogCard />

    <div className='flex flex-wrap my-10 gap-10 justify-evenly items-center ' >
      <img src={logo1} alt="logo1" />
      <img src={logo2} alt="logo1" />
      <img src={logo3} alt="logo1" />
      <img src={logo4} alt="logo1" />
      <img src={logo5} alt="logo1" />
    </div>

    <div className="flex flex-col sm:flex-row text-white px-5 justify-between lg:px-28 py-10 bg-[#009640] ">
      <div> <p className=' text-2xl tracking-wide'>NEWSLETTER</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-3 tracking-wide py-3 ' > Subscribe our Newsletter</h1></div>
      <div>
        <input type="text" className='p-2 bg-transparent sm:-ml-6 h-10 text-white font-sans border-2 border-white' placeholder=' Enter Your Email Address' /><button className='bg-[rgb(63,65,153)]  font-sans h-10 px-2' >Subscribe</button>
      </div>
    </div>

  </div>
  )
}
